export default __webpack_public_path__ + "static/media/scrambled_eggs.ee7cf83d.jpg";